<form novalidate>
  <div
    class="row g-1 mb-2"
    [ngbCollapse]="!showAsbestosQuestion"
    (ngbCollapseChange)="showAsbestosQuestion = $event"
  >
    @if (showAsbestosQuestion) {
      <ng-container
        [wlTrackStep]="{
          toolName: trackToolConfig.toolName,
          step: trackToolConfig.step('asbestos'),
          stepName: trackToolConfig.stepName('asbestos'),
        }"
      >
        <label
          class="col-12 fw-bold"
          *scText="rendering.fields.AsbestosLabel"
        ></label>
        <wl-radio
          class="col-12"
          [rendering]="rendering"
          [step]="trackToolConfig.step('asbestos')"
          [stepName]="trackToolConfig.stepName('asbestos')"
          fieldName="asbest"
          [formsControl]="formState.controls.asbestos"
          [radioItems]="asbestosOptions"
          [inline]="false"
        ></wl-radio>
      </ng-container>
    }
  </div>
  <div
    class="row g-1 mb-2"
    [ngbCollapse]="!showRoofTypeQuestion"
    (ngbCollapseChange)="showRoofTypeQuestion = $event"
  >
    @if (showRoofTypeQuestion) {
      <ng-container
        [wlTrackStep]="{
          toolName: trackToolConfig.toolName,
          step: trackToolConfig.step('roofType'),
          stepName: trackToolConfig.stepName('roofType'),
        }"
      >
        <label
          class="col-12 fw-bold"
          *scText="rendering.fields.RoofTypeLabel"
        ></label>
        <wl-radio
          class="col-12"
          [rendering]="rendering"
          [step]="trackToolConfig.step('roofType')"
          [stepName]="trackToolConfig.stepName('roofType')"
          fieldName="type dak"
          [formsControl]="formState.controls.roofType"
          [radioItems]="roofTypeOptions"
          [inline]="false"
        ></wl-radio>
      </ng-container>
    }
  </div>
  <div
    class="row g-1 mb-2"
    [ngbCollapse]="!showRenovationDateQuestion"
    (ngbCollapseChange)="showRenovationDateQuestion = $event"
  >
    @if (showRenovationDateQuestion) {
      <ng-container
        [wlTrackStep]="{
          toolName: trackToolConfig.toolName,
          step: trackToolConfig.step('renewedRoofWithinTimeLimit'),
          stepName: trackToolConfig.stepName('renewedRoofWithinTimeLimit'),
        }"
      >
        <label
          class="col-12 fw-bold"
          *scText="
            rendering.fields.RoofReplacedLabel
              | interpolate
                : {
                    variables: {
                      maxAge: maximumRoofAge,
                    },
                  }
          "
        ></label>
        <wl-radio
          class="col-12"
          [rendering]="rendering"
          [step]="trackToolConfig.step('renewedRoofWithinTimeLimit')"
          [stepName]="trackToolConfig.stepName('renewedRoofWithinTimeLimit')"
          fieldName="dak vervangen binnen termijn"
          [formsControl]="formState.controls.renewedRoofWithinTimeLimit"
          [radioItems]="roofReplacedOptions"
          [inline]="false"
        ></wl-radio>
      </ng-container>
    }
  </div>
  <button
    class="btn btn-primary"
    (click)="submitForm.emit($event)"
    [disabled]="formState.isInvalid"
    *scText="rendering.fields.SubmitButtonText"
    wlAutomationId="solarPanelSuitabilityCheckForm.submit"
  ></button>
</form>
